<app-header sectionName="Payments"></app-header>

<div class="page" [class.has-bar]="state.selectedCount > 0">
  <nav mat-tab-nav-bar [tabPanel]="panel" class="tabs">
    @for (g of groups; track g.label) {
    <a mat-tab-link [routerLink]="g.views[0].path" queryParamsHandling="preserve" [active]="activeGroup === g">
      <mat-icon class="tab-icon">{{ g.icon }}</mat-icon>
      <span class="tab-label">{{ g.label }}</span>
      <span class="tab-label-short">{{ g.short }}</span>
    </a>
    }
  </nav>

  @if (activeGroup; as g) {
  @if (g.views.length > 1) {
  <nav class="sub-tabs" [attr.aria-label]="g.label">
    @for (v of g.views; track v.path) {
    <a class="sub-tab" [routerLink]="v.path" queryParamsHandling="preserve"
      routerLinkActive="active" ariaCurrentWhenActive="page">
      <mat-icon>{{ v.icon }}</mat-icon>{{ v.label }}
    </a>
    }
  </nav>
  }
  }

  @if (!hideFilters) {
  <section class="list-toolbar">
    <app-supplier-filter class="f-supplier"
      [supplierId]="state.supplierId"
      (supplierIdChange)="onSupplierChange($event)"></app-supplier-filter>

    @if (!hideDates) {
    <mat-form-field appearance="outline" class="f-date" subscriptSizing="dynamic">
      <mat-label>From</mat-label>
      <input matInput type="date" [(ngModel)]="state.fromDate" (change)="filtersChanged()"
        [attr.max]="state.toDate || null">
    </mat-form-field>

    <mat-form-field appearance="outline" class="f-date" subscriptSizing="dynamic">
      <mat-label>To</mat-label>
      <input matInput type="date" [(ngModel)]="state.toDate" (change)="filtersChanged()"
        [attr.min]="state.fromDate || null">
    </mat-form-field>
    }

    @if (hideDates ? state.supplierId : state.hasFilters) {
    <button mat-button type="button" (click)="clearFilters()">
      <mat-icon>filter_alt_off</mat-icon> Clear filters
    </button>
    }
    <span class="spacer"></span>
    <button mat-icon-button type="button" (click)="refresh()" matTooltip="Refresh">
      <mat-icon>refresh</mat-icon>
    </button>
  </section>
  }

  <mat-tab-nav-panel #panel class="panel">
    <router-outlet></router-outlet>
  </mat-tab-nav-panel>
</div>

@if (state.selectedCount > 0) {
<div class="settle-bar">
  <div class="settle-info">
    <span class="settle-count">{{ state.selectedCount }} selected</span>
    <span class="settle-total">{{ state.selectedTotal | number }} <small>Toman</small></span>
    @if (multipleSuppliers) {
    <span class="settle-warn"><mat-icon>warning</mat-icon> More than one supplier selected</span>
    } @else if (state.selectedTotal <= 0) {
    <span class="settle-warn"><mat-icon>warning</mat-icon> Nothing to pay: the selection adds up to 0</span>
    }
  </div>
  <div class="settle-actions">
    <button mat-button type="button" (click)="state.clearSelection()">Clear</button>
    <button mat-flat-button type="button" color="primary" [disabled]="multipleSuppliers || state.selectedTotal <= 0" (click)="settle()">
      <mat-icon>payments</mat-icon> Record settlement
    </button>
  </div>
</div>
}
